import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const ModalFlowBody = ({
  heading,
  infoText,
  image,
  ctaAction,
  buttonComponent
}) => (
  <div className="row">
    <div className="col-xs-12">
      {
        // Added Date.now to remove caching on the gif so that animation replays
        image && <img style={{ height: '240px', marginTop: '-50px' }} alt={`${image}`} src={`/web-hosting/assets/images/${image}.gif?v=${Date.now()}`} />
      }
      <h2>{heading}</h2>
      <p>{infoText}</p>
      <div>
        {
          buttonComponent || <button className="btn btn-primary classic flow-cta remove-click-styling" onClick={ctaAction} >
            <FormattedMessage
              id="hosting.modal_flow_body.next_button_text"
              defaultMessage="Next "
            />
            <i className="ico ico-md icon-right-arrow" /></button>
        }
      </div>
    </div>
  </div>
);

ModalFlowBody.propTypes = {
  heading: PropTypes.string,
  image: PropTypes.string,
  infoText: PropTypes.string,
  ctaAction: PropTypes.func,
  buttonComponent: PropTypes.element
};

export default ModalFlowBody;
